<template>
    <LayoutDashboard title="Bancos">
        <v-card outlined>
            <v-card-title>
                <v-btn color="primary" @click="cadastrarBanco" outlined v-if="$helper.verificaPermissao('cadastrar-banco')">Cadastrar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                </v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="getBancos" :search="search" dense>
                    <template v-slot:item._saldo_tual="{ item }">
                        {{$helper.formatReal(parseFloat(item.saldo_atual))}}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" outlined small @click="visualizarBanco(item)" v-if="$helper.verificaPermissao('visualizar-banco')">Visualizar</v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <ModalCadastroBanco />
    </LayoutDashboard>
</template>

<script>
    import ModalCadastroBanco from "@/pages/banco/ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastroBanco
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id' },
                    { text: 'Banco', value: 'nome'},
                    { text: 'Agência', value: 'agencia'},
                    { text: 'Saldo Atual', value: '_saldo_tual'},
                    
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([
                'getBancos'
            ])
        },
        methods: {
            ...mapActions([
                'listarBancos',
                'visualizarBanco',
                'cadastrarBanco',
            ])
        },
        created() {
            this.listarBancos()
        }
    }
</script>